export default __webpack_public_path__ + "static/media/cage_preview_icon.93a68469.svg";